import * as TYPES from './types';

// 查询权限
export const hasPermission = payload => {
  return payload;
};

// 添加权限
export const pushPermission = payload => ({
  type: TYPES.PUSH_PERMISSION,
  payload,
});

// 删除权限
export const removePermission = payload => ({
  type: TYPES.REMOVE_PERMISSION,
  payload,
});

// 清除权限
export const clearPermission = payload => ({
  type: TYPES.CLEAR_PERMISSION,
  payload,
});
